import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  InputAdornment,
  IconButton,
  InputLabel,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import KeyIcon from "@mui/icons-material/Key";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import { toast } from "react-toastify";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useDispatch, useSelector } from "react-redux";
import { axiosPrivate } from "../../axios/axios";
import { api } from "../API/config";
import { getOTPAndEmail } from "../../Redux/authentication";
import { commonCss } from "../../StyleConfig/CommonCss";
import ErrorProps from "../../Component/Errorprops";
import AuthShell, { authFieldSx, authButtonSx } from "./AuthShell";

const GetPassword = ({ login, handleCloseClick }) => {
  const [isLoading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const userEmail = useSelector((state) => state.auth.getEmailAndOTP.emailId);
  const loginEmail = useSelector((state) => state.auth.loginInfo.emailId);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialValues = {
    emailId: login ? loginEmail : userEmail,
    otp: "",
    password: "",
    confirmPassword: "",
  };
  const onSubmit = (values, { resetForm }) => {
    setLoading(true);
    const updatePassword = {
      emailId: values.emailId,
      password: values.password,
      otp: values.otp,
    };
    console.log(updatePassword);
    const getLink = api.account.resetPassword;
    axiosPrivate
      .post(`${getLink}`, updatePassword)
      .then((res) => {
        console.log(res.data.data);
        dispatch(getOTPAndEmail({ emailId: "" }));
        toast.success("Updated");
        setLoading(false);
        if (login) {
          handleCloseClick();
        } else {
          navigate("/");
        }
        // if(res.data.data.userRole===4){
        //   navigate("/user")

        // }else{
        //   navigate("/reportform")
        // }

        resetForm();
      })
      .catch((err) => {
        console.log(err);
        toast.error(
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {err.response.data.errors !== null
              ? err.response.data.errors.map((d, i) => (
                  <Typography key={i}>
                    {i + 1 + ". " + d.errorMessage}
                  </Typography>
                ))
              : err.response.data.message}
          </Box>,
        );
        setLoading(false);
      });
  };
  const validationSchema = Yup.object({
    otp: Yup.string().required("OTP is required"),
    password: Yup.string()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})/,
        "Must Contain 12 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character",
      )
      .matches(/^\S*$/, "White Spaces are not allowed"),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });

  const handleResend = () => {
    setLoading(true);
    const getLink = api.account.forgetPassword;
    axiosPrivate
      .post(`${getLink}`, { emailId: userEmail })
      .then((res) => {
        toast.success("Please Check Your Email For OTP");
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setLoading(false);
      });
  };
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);

  return (
    <AuthShell
      plain={login}
      title="Reset Password"
      subtitle="Enter the OTP and set your new password."
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ setFieldValue, values }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              width: "100%",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
              <InputLabel>
                <Typography
                  variant="body2"
                  fontWeight={commonCss.labelFontWeight}
                  color={commonCss.labelInputColor}
                >
                  Enter OTP
                </Typography>
              </InputLabel>
              <MuiOtpInput
                length={6}
                value={values.otp}
                onChange={(e) => {
                  setFieldValue("otp", e);
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: commonCss.inputBackgroundColor,
                    borderRadius: commonCss.inputBorderRadius,
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: commonCss.inputBorderColor,
                  },
                }}
              />
              <Typography
                sx={{
                  color: commonCss.blue,
                  fontWeight: 500,
                  fontSize: "0.85rem",
                  textAlign: "end",
                  cursor: "pointer",
                }}
                onClick={handleResend}
              >
                Resend
              </Typography>
              <ErrorMessage name="otp">
                {(error) => <ErrorProps>{error}</ErrorProps>}
              </ErrorMessage>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
              <InputLabel>
                <Typography
                  variant="body2"
                  fontWeight={commonCss.labelFontWeight}
                  color={commonCss.labelInputColor}
                >
                  Password
                </Typography>
              </InputLabel>
              <Field
                as={TextField}
                type={showPassword ? "text" : "password"}
                fullWidth
                size="small"
                name="password"
                sx={authFieldSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <KeyIcon sx={{ color: commonCss.blue }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <ErrorMessage name="password">
                {(error) => <ErrorProps>{error}</ErrorProps>}
              </ErrorMessage>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
              <InputLabel>
                <Typography
                  variant="body2"
                  fontWeight={commonCss.labelFontWeight}
                  color={commonCss.labelInputColor}
                >
                  Confirm Password
                </Typography>
              </InputLabel>
              <Field
                as={TextField}
                type={showConfirmPassword ? "text" : "password"}
                fullWidth
                size="small"
                name="confirmPassword"
                sx={authFieldSx}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <KeyIcon sx={{ color: commonCss.blue }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowConfirmPassword}
                      >
                        {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <ErrorMessage name="confirmPassword">
                {(error) => <ErrorProps>{error}</ErrorProps>}
              </ErrorMessage>
            </Box>

            <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
              <Button
                type="submit"
                variant="contained"
                disabled={isLoading}
                fullWidth
                sx={authButtonSx(isLoading)}
              >
                {isLoading ? "Loading..." : "Reset"}
              </Button>
              <Button
                type="button"
                variant="contained"
                fullWidth
                sx={{
                  py: "0.75rem",
                  color: "white",
                  fontWeight: 600,
                  borderRadius: "0.75rem",
                  textTransform: "none",
                  fontSize: "1rem",
                  display: login ? "flex" : "none",
                  background: commonCss.red,
                  "&:hover": { background: commonCss.red },
                }}
                onClick={handleCloseClick}
              >
                Close
              </Button>
            </Box>

            <Box
              sx={{
                display: login ? "none" : "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: "0.5rem",
              }}
            >
              <Typography sx={{ color: "#6C757D", fontSize: "0.9rem" }}>
                Back to{" "}
                <Link
                  to="/"
                  style={{
                    textDecoration: "none",
                    color: commonCss.blue,
                    fontWeight: 600,
                  }}
                >
                  Log in
                </Link>
              </Typography>
            </Box>
          </Form>
        )}
      </Formik>
    </AuthShell>
  );
};

export default GetPassword;




